import { connect, useSelector } from "react-redux";
import styled from "styled-components";
import { fbTestEmail } from "utils/utils";

const Wrapper = styled.div`
  padding: 1.2rem 1.6rem;
  background-color: #fff4e6;
  border: 1px solid #ffa726;
  border-radius: 8px;
  margin-bottom: 1.6rem;
  position: relative;

  &.hidden {
    display: none;
  }

  .closeBtn {
    position: absolute;
    right: 1.6rem;
    top: 1.2rem;
    height: 2.4rem;
    cursor: pointer;
    background: none;
    border: none;
  }

  .content {
    display: flex;
    align-items: flex-start;
    gap: 1.2rem;
    padding-right: 3.2rem;
  }

  .icon {
    width: 2.4rem;
    height: 2.4rem;
    flex-shrink: 0;
  }

  .text {
    flex: 1;
  }

  .title {
    font-weight: 700;
    color: #e65100;
    margin-bottom: 0.4rem;
  }

  .description {
    color: #bf360c;
    line-height: 1.5;
  }
`;

const MetaRestrictionBanner = ({ className = "", user }) => {
  if (fbTestEmail.includes(user?.email)) {
    return null;
  }

  return (
    <Wrapper className={`${className}`}>
      <div className="content">
        <div className="text">
          <h5 className="title">Meta Channels Temporarily Unavailable</h5>
          <p className="textDescription">
            Due to Meta platform restrictions, Facebook, Instagram and Threads
            account connections, analytics, post creation and other features are
            currently unavailable. We're working to resolve this issue.
          </p>
        </div>
      </div>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(MetaRestrictionBanner);
